require("!!/home/uplanner/rosario-front/node_modules/script-loader/addScript.js")(require("!!/home/uplanner/rosario-front/node_modules/raw-loader/index.js!/home/uplanner/rosario-front/bower_components/moment/locale/es.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/moment/locale/es.js
// module id = 1519
// module chunks = 0